<template>
  <UModal
    :model-value="modelValue"
    :fullscreen="isMobile"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <UCard :ui="modalCard">
      <TModalClose @close="closeModal" />
      <div class="mt-10">
        <div v-if="showLogin && !showRegister && !showContent">
          <AuthLoginNew :is-modal="isModal" @login-success="showContentModal" />
          <div class="text-center text-sm">
            <i18n-t keypath="auth.login.label" tag="span" scope="global">
              <template #register>
                <UButton
                  variant="link"
                  size="md"
                  :padded="false"
                  @click="showRegisterModal()"
                >
                  {{ $t('auth.login.register') }}
                </UButton>
              </template>
            </i18n-t>
          </div>
        </div>
        <div v-if="!showLogin && showRegister && !showContent">
          <AuthRegisterTraveler
            :is-modal="isModal"
            @login-success="showContentModal"
          >
            <i18n-t
              keypath="auth.registrationTraveler.label"
              tag="span"
              scope="global"
            >
              <template #signUp>
                <UButton
                  variant="link"
                  size="md"
                  :padded="false"
                  @click="showLoginModal()"
                >
                  {{ $t('auth.registrationTraveler.signUp') }}
                </UButton>
              </template>
            </i18n-t>
          </AuthRegisterTraveler>
        </div>
        <slot v-if="!showLogin && !showRegister && showContent" />
      </div>
    </UCard>
  </UModal>
</template>
<script setup lang="ts">
import { useUserStore } from '~/modules/auth/stores/userStore'
import { modalCard } from '~/modules/design-system/utils/nuxt-ui-config/components/card'

const userStore = useUserStore()

const { isMobile } = useDevice()

const isModal = true

const showLogin = ref<boolean>(false)
const showRegister = ref<boolean>(false)
const showContent = ref<boolean>(false)

defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue'])

const closeModal = () => {
  emit('update:modelValue', false)
}

const showLoginModal = () => {
  showLogin.value = true
  showRegister.value = false
  showContent.value = false
}

const showRegisterModal = () => {
  showLogin.value = false
  showRegister.value = true
  showContent.value = false
}

const showContentModal = () => {
  showLogin.value = false
  showRegister.value = false
  showContent.value = true
}

const init = async () => {
  const user = userStore.getUserdata
  if (!user.logged) {
    showLoginModal()
  } else {
    showContentModal()
  }
}

userStore.$subscribe(() => {
  init()
})

onMounted(() => {
  init()
})
</script>
